import { cn } from '@data/utils/cn/cn';
import WarningIcon from '@data/assets/warning-outline-svgrepo-com.svg';
import {
  forwardRef,
  type ComponentPropsWithoutRef,
  type ElementType,
} from 'react';

export interface ErrorTextProps extends ComponentPropsWithoutRef<'p'> {
  label?: string;
  icon?: ElementType;
  iconClassName?: string;
}

const ErrorText = forwardRef<HTMLParagraphElement, ErrorTextProps>(
  (
    { label, icon: Icon = WarningIcon, className, iconClassName, ...props },
    ref
  ) => (
    <p
      {...props}
      className={cn(
        'flex items-center font-bold text-brand-cliffordRed ',
        className
      )}
      ref={ref}
    >
      <Icon
        className={
          iconClassName ||
          'mr-2 inline-block h-6 w-6 fill-brand-cliffordRed stroke-brand-cliffordRed'
        }
        aria-hidden
      />
      {label ?? 'Error'}
    </p>
  )
);

ErrorText.displayName = 'ErrorText';

export default ErrorText;
